
import React, { useEffect, useState, useContext } from "react";
import { getMachines } from "../api";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext"

const MachinesList2 = ({ id_c }) => {
    const { t } = useContext(LanguageContext); // 👈 Usa el hook para traer traducciones
    const [data, setData] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            const result = await getMachines(id_c);
            setData(result);
        };
        fetchData();
    }, [id_c]);

    if (!data) return <p>{t('MList1')}</p>;

    return (
        <div className="box1">
            <div className="box9">
                <table className="table5">
                    <thead>
                        <tr>
                            <th>{t('MList2')}</th>
                            <th>{t('MList3')}</th>
                            <th>{t('MList4')}</th>
                            <th>{t('MList5')}</th>
                        {/*}    <th>{t('MList6')}</th> */}
                        {/*}    <th>{t('MList7')}</th>  */}

                        </tr>
                    </thead>
                    <tbody>
                        {data.machines.map((machine) => (
                            <tr key={machine.cod_maq}>
                                <td>{machine.cod_maq}</td>
                                <td>{machine.name_m}</td>
                                <td>{machine.last_activity || "No activity recorded"}</td>


                                <td>
                                    <button
                                        className="button"
                                        onClick={() => {
                                            localStorage.setItem("selectedMachine", JSON.stringify(machine)); // Guardar en localStorage
                                            navigate(`/operations/${machine.cod_maq}`); // Navegar a la página de operaciones
                                        }}
                                    >
                                        Go
                                    </button>
                                </td>
 {/*}
                                <td>
                                    <button className="button">
                                        Go
                                    </button>
                                </td>
                                <td>
                                    <button className="button">
                                        Go
                                    </button>
                                </td>

                                */}

                            </tr>
                        ))}
                    </tbody>
                </table>

            </div>
        </div>
    );
};

export default MachinesList2;